import React from "react";
import { Label, Popup, Icon } from "semantic-ui-react";

interface IFormFieldLabel {
  name: string;
  customFieldName: string;
  staffOnly: boolean;
  isReadonly: boolean;
  isFeeExist: boolean;
  isControllingField: boolean;
  stacked: boolean;
  isContactField?: boolean;
}

const FormFieldLabel = ({ name, customFieldName, isControllingField, staffOnly, isReadonly, isFeeExist, stacked }: IFormFieldLabel) => {
  return (
    <label htmlFor={name} className='control-label'>
      {customFieldName}
      {staffOnly &&
        (stacked ? (
          <Label size='small' circular color='grey' style={{ marginLeft: 10 }}>
            Staff Only
          </Label>
        ) : (
          <Popup
            content='For internal staff only'
            inverted
            trigger={
              <Icon size='large' style={{ marginBottom: 6, marginLeft: 4, color: "#5D5FEF" }} name='user circle' />
            }
          />
        ))}
      {!isReadonly && isFeeExist && isControllingField && !stacked && (
        <Popup
          content='This field is used to calculate a fee'
          inverted
          trigger={
            <div className='fee-icon-container'>
              <Icon className='fee-icon' name='dollar' />
            </div>
          }
        />
      )}
    </label>
  );
};

export default FormFieldLabel;
